import React from 'react';
import { Banner, Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import moment from 'moment';
import sortBy from 'lodash.sortby';
import axiosInstance from '../../actions/AxiosInstance';
import api from '../../actions/EndPoints';

import BannerCalendarIcon from '../../assets/images/BannerCalendarIcon.svg';
import InvitePartnerIcon from '../../assets/images/InvitePartnerIcon.svg';
import FAQIcon from '../../assets/images/FAQIcon.svg';
import TelephoneIcon from '../../assets/images/TelephoneIcon.svg';
import RegisterCoClientIcon from '../../assets/images/RegisterCoClientIcon.svg';

import connectWithUserStore from '../../reducers/connectWithUserStore';
import { showModal, addCoClientEligible, log } from '../../Utils';
import { dispatchOverlayLoad } from '../shared/Analytics';
import isEmpty from 'lodash.isempty';

const BlueBanner = connectWithUserStore(({ state, profiler, dispatch }) => {
    const {
        isCustomerWebView,
        isPrimary,
        numberOfClients,
        engagementStatus,
        currentClientData,
        invitations,
        pendingInvite,
    } = state;

    const { status } = engagementStatus;
    const externalGroupId = state?.planningGroup?.externalId;
    const hasActiveConsent = !isEmpty(currentClientData?.activeConsent);
    const clientType = currentClientData && currentClientData.clientType;
    const hasCalendarMeetingScheduled = Boolean(invitations && invitations.GeneralHelp);
    const isProfilePage = window.location.pathname.includes('/usis/advice/fps/profile');
    const hasFactFindScheduled = Boolean(invitations?.PlanReview);
    const isCNGNStatus =
        state?.planningGroup?.activeEngagement?.engagementStatuses[0]?.status === 'CNGN' &&
        hasActiveConsent;
    const encodedUrlText = pendingInvite?.encodedUrlText;
    const noInvModal =
        window.location.pathname.includes(`/usis/advice/fps/invite/${encodedUrlText}`) ||
        window.location.pathname.includes('/usis/advice/fps/pin-entry') ||
        window.location.pathname.includes('/usis/advice/fps/account-selection');

    const showScheduleApptBtn =
        profiler !== null &&
        !hasFactFindScheduled &&
        ((!isCustomerWebView && isCNGNStatus) ||
            (isProfilePage && hasCalendarMeetingScheduled) ||
            (hasCalendarMeetingScheduled && !isCustomerWebView && isCNGNStatus));

    const showInvitePartnerBtn =
        addCoClientEligible(
            clientType,
            hasActiveConsent,
            isPrimary,
            numberOfClients,
            state?.isConsented,
            status
        ) &&
        profiler?.type !== 'CONSENT_GIVEN_CLIENT';

    const scheduleApptClick = () => {
        getAppointmentDetails()
            .then(
                (apptsToDisplay) =>
                    ((apptsToDisplay && isEmpty(apptsToDisplay)) || !apptsToDisplay) &&
                    redirectToTimeTrade()
            )
            .then(() => {
                showModal('banner-schedule-appt-modal');
                dispatchOverlayLoad('Schedule Appointment Banner Modal');
            })
            .catch((err) => {
                showModal('schedule-appointment-error-modal');
                console.log(err);
            });
    };

    const invitePartnerClick = () => {
        showModal('banner-invite-partner-modal');
        dispatchOverlayLoad('Invite Partner Banner Modal');
    };

    const callUsClick = () => {
        showModal('banner-call-us-modal');
        dispatchOverlayLoad('Call Support Banner Modal');
    };

    const faqClick = () => {
        showModal('banner-faq-modal');
        dispatchOverlayLoad('FAQs Banner Modal');
    };

    const registerCoClientClick = () => {
        showModal('outstanding-coclient-invite');
        dispatchOverlayLoad('Register as Co-Client Modal');
    };

    async function redirectToTimeTrade() {
        try {
            const getTTData = await axiosInstance.get(api.calendarTTAPI, {
                headers: {
                    apikey: `${state.apiKey}`,
                },
            });
            if (getTTData) {
                const { data } = getTTData;
                log(console.log('Appointment Details Call was made on Schedule Appointment Click'));

                if (data !== undefined) {
                    dispatch({
                        type: 'TIME_TRADE_DATA',
                        territoryName: data.territoryName,
                        tType: data.type,
                        parentTerritory: data.parentTerritory,
                        employeeName: data.employeeName,
                        employeeRole: data.employeeRole,
                        invitationId: data.invitationId,
                        employeePhone: data.employeePhone,
                        employeeEmail: data.employeeEmail,
                        schedulingLink: data.schedulingLink,
                        adviceQuestionnaireLink: data.adviceQuestionnaireLink,
                    });
                }
            }
            return getTTData;
        } catch (err) {
            dispatch({
                type: 'TIME_TRADE_FAILURE',
                timeTradeFailure: true,
            });
            throw err;
        }
    }

    async function getAppointmentDetails() {
        try {
            const getApptData = await axiosInstance.get(api.appointmentDetail(externalGroupId), {
                headers: {
                    apikey: `${state.apiKey}`,
                },
            });
            if (getApptData) {
                const { data } = getApptData;
                // Filter appointments with reschedule link and in Scheduled status
                const rescheduleEligibleAppts = data?.results?.filter(
                    (appts) =>
                        appts.invitation &&
                        appts.invitation.reschedulingLink !== '' &&
                        appts.invitation.status === 'Scheduled'
                );
                log(console.log('rescheduleEligibleAppts', rescheduleEligibleAppts));

                // Filter appointments again with endTime in future
                const futureInvitations = rescheduleEligibleAppts?.filter(
                    (appts) => moment(appts.endTime) >= moment()
                );
                log(console.log('futureInvitations', futureInvitations));

                // Sort based on created time - to display latest created appointment
                const sortedByCreatedDates =
                    futureInvitations && sortBy(futureInvitations, 'created').reverse();
                log(console.log('sortedByCreatedDates', sortedByCreatedDates));

                // Display appointments according to their appointmentType
                const apptsToDisplay =
                    sortedByCreatedDates &&
                    sortedByCreatedDates.reduce(
                        (accumulator, appointment) =>
                            Object.assign(accumulator, {
                                [appointment.invitation.appointmentType]: appointment,
                            }),
                        {}
                    );
                log(console.log('apptsToDisplay', apptsToDisplay));

                if (apptsToDisplay && !isEmpty(apptsToDisplay)) {
                    dispatch({
                        type: 'APPOINTMENT_DATA',
                        invitations: apptsToDisplay,
                        apptDataLoading: false,
                        isLoading: false,
                    });
                } else {
                    log(console.log('no appt - show deafult card'));
                    dispatch({
                        type: 'APPOINTMENT_DATA',
                        apptDataLoading: false,
                        isLoading: false,
                        invitations: {},
                    });
                }
                return apptsToDisplay;
            }
        } catch (err) {
            log(console.log('Appt call err: ', err));
            dispatch({
                type: 'TIME_TRADE_FAILURE',
                apptDataLoading: false,
                isLoading: false,
                timeTradeFailure: true,
            });
            window.metricsData.error = 'Timetrade Failure Error';
            throw err;
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: 180,
                justifyContent: 'center',
                background: 'white',
                boxShadow: 'none',
                width: '100%',
            }}>
            <Box sx={{ width: '100%' }}>
                <Banner
                    title={'Retirement Advisory Service'}
                    service={'Planning'}
                    subTitle={'Work with a T. Rowe Price advisor to bring your vision to life.'}
                    buttons={[
                        {
                            text: 'Schedule Appointment',
                            variant: 'secondary',
                            icon: BannerCalendarIcon,
                            onClick: scheduleApptClick,
                            show: showScheduleApptBtn,
                            id: 'header-banner-button-1',
                        },
                        {
                            text: 'Invite Co-client',
                            variant: 'tertiary',
                            icon: InvitePartnerIcon,
                            onClick: invitePartnerClick,
                            show: showInvitePartnerBtn,
                            id: 'header-banner-button-2',
                        },
                        {
                            text: 'Call Us',
                            variant: 'tertiary',
                            icon: TelephoneIcon,
                            onClick: callUsClick,
                            id: 'header-banner-button-3',
                        },
                        {
                            text: 'View FAQs',
                            variant: 'tertiary',
                            icon: FAQIcon,
                            onClick: faqClick,
                            id: 'header-banner-button-4',
                        },
                        {
                            text: 'Register as Co-Client',
                            variant: 'tertiary',
                            icon: RegisterCoClientIcon,
                            onClick: registerCoClientClick,
                            show: Boolean(!noInvModal && encodedUrlText),
                            id: 'header-banner-button-5',
                        },
                    ]}
                />
            </Box>
        </Box>
    );
});

export default BlueBanner;
